export enum AllocationImplementation {
    Manual = 'MANUAL',
    PartiallyAutomatic = 'PARTIALLY_AUTOMATIC',
    Automatic = 'AUTOMATIC'
}
